/**
 * Shared Card Links Component
 *
 * Renders the action links row of a result card. Links without a URL are skipped
 * and a URL already linked by a previous entry is not repeated.
 */

import { h } from 'preact';
import htm from 'htm';

const html = htm.bind(h);

/**
 * Card action links row.
 *
 * @param {Object} props
 * @param {Array<{href: string, text: string}>} props.links - Links in display order.
 */
export function CardLinks({ links }) {
  const seen = new Set();
  const visible = (links || []).filter(({ href }) => {
    if (!href || seen.has(href)) return false;
    seen.add(href);
    return true;
  });

  if (!visible.length) return null;

  return html`
    <div class="mta-map-popup-links" style="margin-top:8px;">
      ${visible.map(({ href, text }) => html`
        <a href="${href}" target="_blank" rel="noopener noreferrer" class="mta-map-popup-link">${text}</a>
      `)}
    </div>
  `;
}
